export default {
  header: 'Dobbiamo verificare il tuo numero di telefono',
  buttons: {
    confirm: 'Conferma',
  },
  toasts: {
    invalid_code: 'Codice non valido. Riprova.',
  },
};
